import React from 'react'
import { ErrorMessage, Field, getIn } from 'formik'
import ErrorPopUp from '../../Shared/ErrorPopUp'
import NumberFormat from 'react-number-format'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import AsyncProductSelect from '../../Shared/AsyncProductSelect'

export default ({
  touched,
  errors,
  setFieldValue,
  values,
  handleBlur,
  categoryType,
  onChangeIsGradeTwo,
  index,
  data
}) => (
  <fieldset className="fieldset blue-fieldset">
    <legend>تایل برش شده (انبار نیمه ساخته)</legend>
    <div className="row">
      <div className="col-lg-12 col-sm-12">
        <FormControlLabel
          control={
            <Checkbox
              size="medium"
              checked={values.items[index].selectFromList}
              onChange={e => {
                setFieldValue(
                  `items[${index}][selectFromList]`,
                  e.target.checked
                )
                if (!e.target.checked) {
                  setFieldValue(
                    `items[${index}][id]`,
                    '00000000-0000-0000-0000-000000000000'
                  )
                }
              }}
              name="selectFromList"
              color="primary"
            />
          }
          label="انتخاب از لیست"
        />
      </div>
      {values.items[index].selectFromList ? (
        <div className="form-inline">
          <div className="col-lg-6 col-sm-12">
            <AsyncProductSelect
              brandId={values.brandId}
              // categoryType={values.relatedProducts.filter(el => el.unitType === 7 && el.relatedProductType === 0)[0].categoryType}
              categoryId={values.items[index].categoryId}
              defaultValue={values.items[index].relatedProductId}
              onChange={val => {
                setFieldValue(`items[${index}][relatedProductId]`, val.value)
              }}
              className={
                getIn(errors, `items[${index}].relatedProductId`)
                  ? 'semantic-select-box has-error'
                  : 'semantic-select-box'
              }
            />
            <ErrorMessage
              component={ErrorPopUp}
              name={`items[${index}].relatedProductId`}
            />
          </div>
        </div>
      ) : (
        <div className="form-inline">
          {/* {JSON.stringify(data)} */}
          <div className="col-md-6">
            <label>نام کالا</label>
            <input
              type="text"
              value={values.items[index].name}
              onBlur={handleBlur}
              name="name"
              // autoFocus
              onChange={e => {
                setFieldValue(`items[${index}][name]`, e.target.value)
              }}
              className={
                getIn(errors, `items[${index}].name`)
                  ? 'text-input has-error'
                  : 'text-input'
              }
            />
            {/* <ErrorMessage component={ErrorPopUp} name={`items[${index}].name`} /> */}
          </div>

          {/* <div className="col-md-3">
          <label>دسته بندی</label>
          <AsyncCategorySelect
            // onlySecondaryClass={true}
            categoryType={categoryType}
            defaultValue={values.items[index].categoryId}
            name="categoryId"
            onChange={(val, measurementType) => {

              setFieldValue(`items[${index}][categoryId]`, val)
              setFieldValue(`items[${measurementType}][categoryId]`, measurementType)

            }}
            className="semantic-select-box"
          />
          <ErrorMessage component={ErrorPopUp} name={`items[${index}].categoryId`} />
        </div> */}

          <div className="col-md-2">
            <label>کد کالا</label>
            <Field
              type="text"
              value={values.items[index].extraCode}
              name="extraCode"
              onChange={e => {
                setFieldValue(`items[${index}][extraCode]`, e.target.value)
              }}
              onBlur={handleBlur}
              className={
                getIn(errors, `items[${index}].extraCode`)
                  ? 'text-input bold has-error'
                  : 'text-input bold'
              }
            />
            {/* <ErrorMessage component={ErrorPopUp} name={`items[${index}].extraCode`} /> */}
          </div>

          {/* <div className="col-md-2">
          <label>کد کوتاه</label>
          <NumberFormat isNumericString allowNegative={false}
            defaultValue={values.items[index].shortExtraCode}
            value={values.items[index].shortExtraCode}
            name="shortExtraCode"
            onChange={(e) => {
              setFieldValue(`items[${index}][shortExtraCode]`, e.target.value)
            }}
            onBlur={handleBlur}
            className="text-input"
          />
          <ErrorMessage component={ErrorPopUp} name={`items[${index}].shortExtraCode`} />
        </div> */}

          <div className="clearfix" />

          {/* <div className="col-md-6">
          <label>توضیحات</label>
          <input type="text"
            value={values.items[index].description}
            onBlur={handleBlur}
            name="description"
            // autoFocus
            className="text-input"
            onChange={(e) => {
              setFieldValue(`items[${index}][description]`, e.target.value)
            }}
          />
          <ErrorMessage component={ErrorPopUp} name={`items[${index}].description`} />
        </div>

        <div className="clearfix"></div> */}

          {/* <div className="col-md-3 col-sm-4">
          <label>واحد اصلی</label>
          <MeasurementTypeSelect
            defaultValue={values.items[index].measurementType}
            onChange={val => {
              setFieldValue(`items[${index}][measurementType]`, val)
            }}
            className="text-input required rtl"
          />
          <ErrorMessage component={ErrorPopUp} name={`items[${index}].measurementType`} />
        </div> */}

          {/* <div className="col-md-3 col-sm-4">
          <label>واحد فرعی</label>
          <MeasurementTypeSelect
            defaultValue={values.items[index].subMeasurementType}
            onChange={val => {
              setFieldValue(`items[${index}][subMeasurementType]`, val)
            }}
            className={
              getIn(errors, "subMeasurementType") &&
                getIn(touched, "subMeasurementType")
                ? "text-input has-error rtl"
                : "text-input required rtl"
            }
          />
          <ErrorMessage component={ErrorPopUp} name={`items[${index}].subMeasurementType`} />
        </div>

        <div className="col-md-3 col-sm-4">
          <label>ضریب تبدیل</label>
          <NumberFormat isNumericString allowNegative={false}
            defaultValue={values.items[index].conversionUnit}
            value={values.items[index].conversionUnit}
            name="conversionUnit"
            onChange={(e) => {
              setFieldValue(`items[${index}][conversionUnit]`, e.target.value)
            }}
            onBlur={handleBlur}
            className={getIn(touched, "conversionUnit") ? getIn(errors, "conversionUnit") ? "text-input has-error" : "text-input" : "text-input has-error"}
          />
          <ErrorMessage component={ErrorPopUp} name={`items[${index}].conversionUnit`} />
        </div> */}

          {/* <div className="col-md-3 col-sm-12">
          <label>تعداد تایل در هر واحد</label>
          <NumberFormat isNumericString allowNegative={false}
            defaultValue={values.items[index].numberOfParts}
            value={values.items[index].numberOfParts}
            name="conversionUnit"
            onChange={(e) => {
              setFieldValue(`items[${index}][numberOfParts]`, e.target.value)
            }}
            onBlur={handleBlur}
            className={getIn(touched, "numberOfParts") ? getIn(errors, "numberOfParts") ? "text-input has-error" : "text-input" : "text-input has-error"}
          />
          <ErrorMessage component={ErrorPopUp} name={`items[${index}].numberOfParts`} />
        </div> */}
        </div>
      )}
    </div>
  </fieldset>
)
